export const BRAND_TYPES = {
  OFFICIAL: 'OFFICIAL',
  NON_OFFICIAL: 'NON_OFFICIAL'
};
